import index from './multiselect'

export default index